import React from "react";
import { NavLink } from "react-router-dom";

const navbarbar = () => {
  return (
    <nav className="navbar">
      <ul className="navbar-list">
        <li className="navbar-list-item">
          <NavLink to="/home" className="navbar-list-item-link">
            Home
          </NavLink>
        </li>
        <li className="navbar-list-item">
          <NavLink to="/about" className="navbar-list-item-link">
            About
          </NavLink>
        </li>
        <li className="navbar-list-item">
          <NavLink to="/menu" className="navbar-list-item-link">
            Menu
          </NavLink>
        </li>

        <li className="navbar-list-item">
          <NavLink to="/contact" className="navbar-list-item-link">
            Contact
          </NavLink>
        </li>
      </ul>
    </nav>
  );
};

export default navbarbar;
